import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import { AppFunctions, AppFunctionsContext } from "./App";

/**
 * メニュー部分を表すコンポーネント
 * 
 * @returns 
 */
export default function Menu(): JSX.Element {
	/** ログインユーザ情報 */
	const [updateTime, setUpdateTime] = useState<Date>(new Date());

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	// 初回のみ実行
	useEffect(() => {
		// api通信をした後に、表示時間を更新する。
		axios.interceptors.response.use((response) => {
			setUpdateTime(new Date());
			return response;
		}, (error) => {
			setUpdateTime(new Date());
			return Promise.reject(error);
		});
	}, []);

	/** ログイン情報 */
	const login = appFunctions?.getLogin();

	/** ページ名 */
	const page = appFunctions?.getPage();

	/**
	 * 送信履歴ページを表示する。
	 */
	const handleHistoryClick = () => {
		appFunctions?.setPage('history');
	};

	/**
	 * ダウンロードページを表示する。
	 */
	const handleDownloadClick = () => {
		appFunctions?.setPage('download');
	};

	/**
	 * ログ検索ページを表示する。
	 */
	const handleLogSeachlick = () => {
		appFunctions?.setPage('logseach');
	};

	// 描画する
	return (
		<div id="report_menu" className="navbar navbar-fixed-top" style={{ top: '40px', zIndex: 1, marginBottom: '10px' }}>
			<div className="navbar-inner">
				<div className="container">
					{login != undefined &&
						<ul className="nav">
							<li id="fup" className={page == 'history' ? 'active' : undefined}><a onClick={handleHistoryClick}>送信履歴</a></li>
							<li id="deli" className={page == 'download' ? 'active' : undefined}><a onClick={handleDownloadClick}>ダウンロード</a></li>
							<li id="deli" className={page == 'logseach' ? 'active' : undefined}><a onClick={handleLogSeachlick}>ログ検索</a></li>
						</ul>
					}
					<ul className="nav pull-right">
						<div id="digital-clock">{updateTime.toLocaleString()}</div>
					</ul>
				</div>
			</div>
		</div>
	);
}